import { memo, PropsWithChildren } from 'react';
import { BottomSheet } from 'react-spring-bottom-sheet';

import CloseIcon from '@/assets/icons/icon-close.svg?react';

import styles from './DialogBottom.module.scss';

export interface BottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  onSpringStart?: () => void;
  onSpringEnd?: () => void;
}

function DialogBottom(props: PropsWithChildren<BottomSheetProps>) {
  const { isOpen, onClose, children, onSpringStart, onSpringEnd } = props;

  return (
    <BottomSheet
      className={styles.root}
      open={isOpen}
      onDismiss={onClose}
      onSpringStart={onSpringStart}
      onSpringEnd={onSpringEnd}
      header={
        <div>
          <button onClick={onClose} className={styles.close}>
            <CloseIcon />
          </button>
        </div>
      }
    >
      <div className={styles.content}>{children}</div>
    </BottomSheet>
  );
}

export default memo(DialogBottom);
